<app-main-layout>
  <div class="bg-gray-50 min-h-screen">
  <div class="py-6 px-4 sm:px-6 max-w-[1200px] mx-auto">

    <!-- Header -->
    <div class="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-6">
      <div class="flex items-center gap-4 min-w-0">
        <button type="button" (click)="backToList()"
          class="h-10 w-10 flex-shrink-0 rounded-full bg-white border border-gray-200 shadow-sm flex items-center justify-center text-gray-500 hover:text-gray-900 hover:border-amber-300 transition-colors"
          matTooltip="Back to customers" aria-label="Back to customers">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <span class="h-12 w-12 rounded-full flex items-center justify-center text-base font-bold flex-shrink-0"
          [ngClass]="!isActive ? 'bg-gray-100 text-gray-400' : isTrade ? 'bg-neutral-900 text-amber-400' : 'bg-gradient-to-br from-amber-300 to-amber-500 text-neutral-900'">{{ initials() }}</span>
        <div class="min-w-0">
          <div class="flex items-center gap-1.5 text-xs text-gray-400">
            <button type="button" class="hover:text-gray-700" (click)="backToList()">Customers</button>
            <mat-icon class="!text-[14px] !h-3.5 !w-3.5">chevron_right</mat-icon>
            <span>{{ isEdit ? 'Edit' : 'New' }}</span>
          </div>
          <h1 class="text-2xl font-bold text-gray-900 tracking-tight truncate max-w-[70vw] lg:max-w-[520px]">
            {{ loading ? 'Loading…' : (firstname || lastname ? currentName : (isEdit ? 'Customer' : 'New customer')) }}
          </h1>
          @if (isEdit && detail) {
            <div class="mt-0.5 flex flex-wrap items-center gap-2 text-xs text-gray-500">
              <span class="truncate">{{ detail.useremail }}</span>
              @if (isTrade) { <span class="font-semibold px-2 py-0.5 rounded-md bg-neutral-900 text-amber-400">Trade account</span> }
              @if (!detail.isActive) { <span class="font-semibold px-2 py-0.5 rounded-md bg-rose-50 text-rose-600">Deactivated</span> }
            </div>
          }
        </div>
      </div>
      @if (isEdit) {
      <div class="flex items-center gap-2 flex-wrap">
        @if (navTotal) {
          <app-record-nav noun="customer" listName="Customers" [position]="position" [total]="navTotal"
            [prevName]="nameOf(prev?.c)" [nextName]="nameOf(next?.c)" [disabled]="loading || saving" (prev)="goTo(prev)" (next)="goTo(next)"></app-record-nav>
        }
        <button type="button" class="flex items-center gap-1.5 px-4 py-2.5 rounded-xl border border-gray-200 bg-white text-sm font-semibold text-gray-700 hover:border-sky-300 hover:bg-sky-50 shadow-sm transition-colors" (click)="viewOrders()">
          <mat-icon class="!text-[18px] !h-[18px] !w-[18px] text-sky-600">receipt_long</mat-icon> Orders
        </button>
      </div>
      }
    </div>

    @if (loading) {
      <div class="rounded-2xl bg-white border border-gray-100 py-24 flex flex-col items-center justify-center text-sm text-gray-500">
        <mat-spinner diameter="40"></mat-spinner><span class="mt-3">Loading customer&hellip;</span>
      </div>
    } @else if (notFound) {
      <div class="rounded-3xl border-2 border-dashed border-gray-200 bg-white py-16 text-center">
        <span class="mx-auto h-14 w-14 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center"><mat-icon class="!text-[28px] !h-7 !w-7">person_off</mat-icon></span>
        <p class="mt-3 text-sm font-semibold text-gray-700">That customer couldn't be found</p>
        <button type="button" class="mt-4 text-xs font-semibold text-amber-700 hover:underline" (click)="backToList()">Back to customers</button>
      </div>
    } @else {

    <div class="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_360px] gap-6 items-start">

      <!-- ============ FORM ============ -->
      <div class="flex flex-col gap-5">

        <!-- Details -->
        <section class="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
          <div class="flex items-center gap-3 mb-5">
            <span class="h-9 w-9 rounded-xl bg-amber-50 text-amber-700 flex items-center justify-center"><mat-icon class="!text-[19px] !h-[19px] !w-[19px]">badge</mat-icon></span>
            <div><h2 class="text-[15px] font-bold text-gray-900">Details</h2><p class="text-xs text-gray-500">{{ isEdit ? 'Name and contact details' : 'Creates the account - they set their own password from the login page' }}</p></div>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">First name *</label>
              <input type="text" name="firstname" [(ngModel)]="firstname" placeholder="First name" maxlength="200"
                class="mt-1.5 w-full px-3.5 py-2.5 rounded-xl border bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm" [ngClass]="show('firstname') ? 'border-red-300' : 'border-gray-200'" />
              @if (show('firstname')) { <div class="mt-1 text-xs text-red-600">{{ show('firstname') }}</div> }
            </div>
            <div>
              <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Last name *</label>
              <input type="text" name="lastname" [(ngModel)]="lastname" placeholder="Last name" maxlength="200"
                class="mt-1.5 w-full px-3.5 py-2.5 rounded-xl border bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm" [ngClass]="show('lastname') ? 'border-red-300' : 'border-gray-200'" />
              @if (show('lastname')) { <div class="mt-1 text-xs text-red-600">{{ show('lastname') }}</div> }
            </div>
            <div class="sm:col-span-2">
              <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Email {{ isEdit ? '' : '*' }}</label>
              @if (isEdit) {
                <div class="mt-1.5 flex items-center gap-2 px-3.5 py-2.5 rounded-xl border border-gray-100 bg-gray-50 text-sm text-gray-600">
                  <mat-icon class="!text-[16px] !h-4 !w-4 text-gray-400">lock</mat-icon>{{ email }}
                  <span class="ml-auto text-[11px] text-gray-400">their login - can't be changed here</span>
                </div>
              } @else {
                <input type="email" name="email" [(ngModel)]="email" placeholder="name@example.com"
                  class="mt-1.5 w-full px-3.5 py-2.5 rounded-xl border bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm" [ngClass]="show('email') ? 'border-red-300' : 'border-gray-200'" />
                @if (show('email')) { <div class="mt-1 text-xs text-red-600">{{ show('email') }}</div> }
              }
            </div>
            <div>
              <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Display name / company</label>
              <input type="text" name="displayname" [(ngModel)]="displayname" placeholder="e.g. JCR Landscapes" maxlength="300"
                class="mt-1.5 w-full px-3.5 py-2.5 rounded-xl border bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm" [ngClass]="show('displayname') ? 'border-red-300' : 'border-gray-200'" />
              @if (show('displayname')) { <div class="mt-1 text-xs text-red-600">{{ show('displayname') }}</div> }
            </div>
            <div>
              <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Phone</label>
              <input type="tel" name="phone" [(ngModel)]="phone" placeholder="07123 456789 or +44 7123 456789"
                class="mt-1.5 w-full px-3.5 py-2.5 rounded-xl border bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm" [ngClass]="show('phone') ? 'border-red-300' : 'border-gray-200'" />
              @if (show('phone')) { <div class="mt-1 text-xs text-red-600">{{ show('phone') }}</div> }
            </div>
            <div>
              <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">VAT number</label>
              <input type="text" name="vatnumber" [(ngModel)]="vatnumber" placeholder="GB123456789"
                class="mt-1.5 w-full px-3.5 py-2.5 rounded-xl border bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm font-mono uppercase" [ngClass]="show('vatnumber') ? 'border-red-300' : 'border-gray-200'" />
              @if (show('vatnumber')) { <div class="mt-1 text-xs text-red-600">{{ show('vatnumber') }}</div> }
            </div>
          </div>
        </section>

        <!-- Membership -->
        @if (isEdit && canManage) {
        <section class="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
          <div class="flex items-center gap-3 mb-5">
            <span class="h-9 w-9 rounded-xl bg-amber-50 text-amber-700 flex items-center justify-center"><mat-icon class="!text-[19px] !h-[19px] !w-[19px]">workspace_premium</mat-icon></span>
            <div><h2 class="text-[15px] font-bold text-gray-900">Membership</h2><p class="text-xs text-gray-500">Any tier other than Non member makes them a trade account</p></div>
          </div>
          <div class="grid grid-cols-2 sm:grid-cols-5 gap-2.5">
            @for (t of tiers; track t.key) {
            <button type="button" class="relative flex flex-col items-center gap-1.5 px-2 py-3.5 rounded-2xl border-2 transition-all"
              [ngClass]="usertype === t.key ? 'border-amber-400 bg-amber-50/70' : 'border-gray-100 bg-gray-50/50 hover:border-gray-200 hover:bg-white'" (click)="usertype = t.key">
              @if (usertype === t.key) { <mat-icon class="absolute top-2 right-2 !text-[16px] !h-4 !w-4 text-amber-500">check_circle</mat-icon> }
              <span class="h-10 w-10 rounded-xl flex items-center justify-center"
                [ngClass]="t.key === 'BRONZE' ? 'bg-orange-100 text-orange-700' : t.key === 'SILVER' ? 'bg-slate-200 text-slate-700' : t.key === 'GOLD' ? 'bg-amber-200 text-amber-800' : t.key === 'PLATINUM' ? 'bg-violet-100 text-violet-700' : 'bg-white border border-gray-200 text-gray-500'">
                <mat-icon class="!text-[20px] !h-5 !w-5">{{ t.icon }}</mat-icon>
              </span>
              <span class="text-sm font-bold text-gray-900">{{ t.label }}</span>
              <span class="text-[10px] text-gray-400">{{ t.hint }}</span>
            </button>
            }
          </div>
        </section>
        }

        <!-- Account -->
        @if (isEdit && canManage) {
        <section class="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
          <div class="flex items-center gap-3 mb-5">
            <span class="h-9 w-9 rounded-xl bg-amber-50 text-amber-700 flex items-center justify-center"><mat-icon class="!text-[19px] !h-[19px] !w-[19px]">manage_accounts</mat-icon></span>
            <div><h2 class="text-[15px] font-bold text-gray-900">Account</h2><p class="text-xs text-gray-500">Whether they can log in and order on the website</p></div>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <button type="button" class="flex items-center gap-3 rounded-xl border-2 px-4 py-3 text-left transition-all" [ngClass]="isActive ? 'border-emerald-400 bg-emerald-50/60' : 'border-gray-200 hover:border-gray-300'" (click)="isActive = true">
              <mat-icon class="!text-[22px] !h-[22px] !w-[22px]" [ngClass]="isActive ? 'text-emerald-600' : 'text-gray-300'">check_circle</mat-icon>
              <span><span class="block text-sm font-semibold text-gray-900">Active</span><span class="block text-xs text-gray-500">Can log in and place orders</span></span>
            </button>
            <button type="button" class="flex items-center gap-3 rounded-xl border-2 px-4 py-3 text-left transition-all" [ngClass]="!isActive ? 'border-rose-400 bg-rose-50/60' : 'border-gray-200 hover:border-gray-300'" (click)="isActive = false">
              <mat-icon class="!text-[22px] !h-[22px] !w-[22px]" [ngClass]="!isActive ? 'text-rose-600' : 'text-gray-300'">block</mat-icon>
              <span><span class="block text-sm font-semibold text-gray-900">Deactivated</span><span class="block text-xs text-gray-500">Can't log in - their orders are kept</span></span>
            </button>
          </div>
          <div class="mt-5">
            <app-set-password [userId]="customerId" [name]="firstname || 'this customer'"></app-set-password>
          </div>
        </section>
        } @else if (isEdit) {
          <app-set-password [userId]="customerId" [name]="firstname || 'this customer'"></app-set-password>
        }
      </div>

      <!-- ============ SIDE ============ -->
      <div class="flex flex-col gap-5 lg:sticky lg:top-4">
        @if (isEdit && detail) {
          <section class="relative overflow-hidden rounded-2xl bg-neutral-900 text-white p-5 shadow-sm">
            <div class="pointer-events-none absolute -right-10 -top-10 h-36 w-36 rounded-full bg-amber-400/20 blur-2xl"></div>
            <div class="relative">
              <div class="text-[11px] font-bold uppercase tracking-[0.15em] text-amber-400">At a glance</div>
              <div class="mt-3 text-[10px] uppercase tracking-wide text-white/50">Total spent</div>
              <div class="text-3xl font-bold tabular-nums">£{{ detail.stats.totalSpent | number:'1.0-0' }}</div>
              <div class="mt-4 grid grid-cols-3 gap-2">
                <div class="rounded-xl bg-white/[0.07] px-3 py-2"><div class="text-[10px] uppercase tracking-wide text-white/50">Orders</div><div class="text-lg font-bold tabular-nums">{{ detail.stats.orderCount | number }}</div></div>
                <div class="rounded-xl bg-white/[0.07] px-3 py-2"><div class="text-[10px] uppercase tracking-wide text-white/50">Avg</div><div class="text-lg font-bold tabular-nums">£{{ detail.stats.avgOrder | number:'1.0-0' }}</div></div>
                <div class="rounded-xl bg-white/[0.07] px-3 py-2"><div class="text-[10px] uppercase tracking-wide text-white/50">Points</div><div class="text-lg font-bold tabular-nums">{{ detail.userpoints | number }}</div></div>
              </div>
              <div class="mt-4 space-y-1.5 text-xs">
                <div class="flex justify-between"><span class="text-white/50">Joined</span><span>{{ detail.createdOn ? (detail.createdOn | date:'d MMM yyyy') : '–' }}</span></div>
                <div class="flex justify-between"><span class="text-white/50">First order</span><span>{{ detail.stats.firstOrder ? (detail.stats.firstOrder | date:'d MMM yyyy') : '–' }}</span></div>
                <div class="flex justify-between"><span class="text-white/50">Latest order</span><span>{{ detail.stats.lastOrder ? (detail.stats.lastOrder | date:'d MMM yyyy') : '–' }}</span></div>
                @if (detail.stats.discounts) { <div class="flex justify-between"><span class="text-white/50">Discounts used</span><span>£{{ detail.stats.discounts | number:'1.0-0' }}</span></div> }
              </div>
            </div>
          </section>

          <section class="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
            <div class="px-5 py-3 border-b border-gray-100 flex items-center justify-between">
              <span class="flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider text-gray-400"><mat-icon class="!text-[16px] !h-4 !w-4">receipt_long</mat-icon> Recent orders</span>
              @if (detail.recentOrders.length) { <button class="text-[11px] font-semibold text-amber-700 hover:underline" (click)="viewOrders()">See all</button> }
            </div>
            @if (!detail.recentOrders.length) {
              <div class="px-5 py-8 text-center text-sm text-gray-400">No orders yet</div>
            } @else {
              <div class="p-2 max-h-[320px] overflow-y-auto">
                @for (o of detail.recentOrders; track o.orderId) {
                <button class="w-full text-left px-3 py-2 rounded-xl hover:bg-amber-50/70 transition-colors" (click)="openOrder(o.orderNo)">
                  <div class="flex items-center justify-between gap-2"><span class="font-semibold text-sm text-gray-900">#{{ o.orderNo }}</span><span class="font-bold text-sm text-gray-900 tabular-nums">£{{ o.netAmount | number:'1.2-2' }}</span></div>
                  <div class="flex items-center justify-between gap-2 mt-0.5">
                    <span class="text-xs text-gray-400">{{ o.orderDate | date:'d MMM yyyy' }}</span>
                    <span class="text-[10px] font-semibold px-2 py-0.5 rounded-md capitalize" [ngClass]="statusClass(o.orderStatus)">{{ o.orderStatus | lowercase }}</span>
                  </div>
                </button>
                }
              </div>
            }
          </section>

          @if (detail.addresses.length) {
          <section class="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
            <div class="px-5 py-3 border-b border-gray-100 flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider text-gray-400"><mat-icon class="!text-[16px] !h-4 !w-4">location_on</mat-icon> Saved addresses</div>
            <div class="p-2">
              @for (a of detail.addresses; track a.id) {
              <a class="block px-3 py-2 rounded-xl hover:bg-amber-50/70" [href]="mapsUrl(a)" target="_blank" rel="noopener" matTooltip="Open in Google Maps">
                <div class="flex items-center gap-2"><span class="text-sm font-semibold text-gray-800 truncate">{{ (a.firstName + ' ' + a.lastName).trim() }}</span>@if (a.isDefault) { <span class="text-[10px] font-semibold px-1.5 py-0.5 rounded-md bg-emerald-50 text-emerald-700">Default</span> }</div>
                <div class="text-xs text-gray-500">{{ a.address1 }}{{ a.address2 ? ', ' + a.address2 : '' }}, {{ a.city }} <span class="font-semibold text-gray-700">{{ a.postCode }}</span></div>
              </a>
              }
            </div>
          </section>
          }
        } @else {
          <section class="rounded-2xl border border-dashed border-gray-200 bg-white p-6 text-center">
            <span class="mx-auto h-12 w-12 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center"><mat-icon>person_add</mat-icon></span>
            <p class="mt-3 text-sm font-semibold text-gray-800">A new account</p>
            <p class="mt-1 text-xs text-gray-500 leading-relaxed">Once it's created you can set their membership tier, and their orders and addresses show here.</p>
          </section>
        }
      </div>
    </div>

    <!-- Save bar -->
    <div class="sticky bottom-4 z-20 mt-6 flex flex-wrap items-center justify-between gap-3 bg-white/95 backdrop-blur rounded-2xl border border-gray-200 shadow-lg px-5 py-3">
      <div class="min-w-0 text-sm">
        @if (!dirty && isEdit) {
          <span class="text-gray-400">No changes yet</span>
        } @else if (firstError) {
          <span class="flex items-center gap-1.5" [ngClass]="tried ? 'text-red-600' : 'text-amber-700'"><mat-icon class="!text-[16px] !h-4 !w-4 flex-shrink-0">error_outline</mat-icon><span class="truncate">{{ firstError }}</span></span>
        } @else {
          <span class="flex items-center gap-1.5 text-emerald-600"><mat-icon class="!text-[16px] !h-4 !w-4">check_circle</mat-icon>Ready to save</span>
        }
      </div>
      <div class="flex items-center gap-2 ml-auto">
        @if (dirty) {
          <button type="button" class="px-4 py-2.5 rounded-xl text-sm font-semibold text-gray-600 hover:bg-gray-100 transition-colors" (click)="discard()">Discard</button>
        } @else {
          <button type="button" class="px-4 py-2.5 rounded-xl text-sm font-semibold text-gray-600 hover:bg-gray-100 transition-colors" (click)="backToList()">Back to list</button>
        }
        <button type="button" [disabled]="saving || (isEdit && !dirty)" (click)="save()"
          class="flex items-center gap-1.5 px-6 py-2.5 rounded-xl bg-gradient-to-b from-amber-400 to-amber-500 text-neutral-900 text-sm font-bold shadow-sm hover:from-amber-300 hover:to-amber-400 active:scale-[0.98] transition-all disabled:opacity-40 disabled:pointer-events-none">
          @if (saving) { <span class="inline-block h-4 w-4 rounded-full border-2 border-neutral-900 border-t-transparent animate-spin"></span> }
          @else { <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">{{ isEdit ? 'save' : 'person_add' }}</mat-icon> }
          {{ isEdit ? 'Save changes' : 'Create customer' }}
        </button>
      </div>
    </div>
    }
  </div>
  </div>
</app-main-layout>
